/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable */
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import notification from "../../components/notification";

// Define a service using a base URL and expected endpoints
export const kifAdminApi = createApi({
  reducerPath: "kifAdminApi",
  baseQuery: fetchBaseQuery({
    // baseUrl: process.env.REACT_APP_API_URL,
    // baseUrl: 'https://api-myhcare.thesynergyworks.com/api/v1',
    // baseUrl: 'https://api.telesecure360.com/api/v1',
    baseUrl: process.env.REACT_APP_BASENAME,
    prepareHeaders: (headers) => {
      if (localStorage.getItem("token"))
        headers.set("Authorization", localStorage.getItem("token"));
      return headers;
    },
  }),
  tagTypes: [
    "doctors",
    "patients",
    "user",
    "reviews",
    "notes",
    "recommended_doctors",
    "recommended_specialities",
    "clinics",
    "clinic_staff",
    "tax",
    "pharmacy",
    "pharmacy_user",
    "appointmentList",
    "screenings",
    "providerFeeRevision",
    "FeeRevisionHistory",
    "masterDocument",
    "Transactions",
  ],
  endpoints: (builder) => ({
    login: builder.mutation({
      query: ({ email, password }) => ({
        url: "/users/login",
        method: "POST",
        body: {
          email,
          password,
          deviceType: 0,
          uuid: localStorage.getItem("uuid"),
          role: 1,
        },
      }),
      onQueryStarted(body, { queryFulfilled }) {
        queryFulfilled.catch((error) =>
          notification({
            title: "Invalid credentials!",
            description:
              error?.error?.data?.message ||
              "Either your email or password is invalid",
            type: "error",
          }),
        );
      },
    }),
    verifyTwoFactorAuth: builder.mutation({
      query: ({ authCode, token }) => ({
        url: "/users/verifyTwoFactorAuth",
        method: "PUT",
        headers: { Authorization: token },
        body: { authCode, uuid: localStorage.getItem("uuid") },
      }),
      onQueryStarted(body, { queryFulfilled }) {
        queryFulfilled.catch((error) =>
          notification({
            title: "Invalid OTP!",
            description: "Please enter correct otp",
          }),
        );
      },
    }),
    forgotPassword: builder.mutation({
      query: ({ email, role }) => ({
        url: "/users/forgotPassword",
        method: "PUT",
        body: { email, role },
      }),
      onQueryStarted(body, { queryFulfilled }) {
        queryFulfilled
          .then(() =>
            notification({
              title: "Email sent successfully!",
              description:
                "Check your email for directions to reset your password",
              type: "success",
            }),
          )
          .catch(() =>
            notification({
              title: "Invalid Email!",
              description: "No user found with that email",
              type: "error",
            }),
          );
      },
    }),
    resetPassword: builder.mutation({
      query: ({ forgotPasswordToken, password, confirmPassword }) => ({
        url: "/users/resetPassword",
        method: "PUT",
        body: { forgotPasswordToken, password, confirmPassword },
      }),
      onQueryStarted(body, { queryFulfilled }) {
        queryFulfilled
          .then(() =>
            notification({
              title: "Password Updated!",
              description: "Please login to continue",
              type: "success",
            }),
          )
          .catch(() =>
            notification({
              title: "Unable to update password!",
              description:
                "Please ensure that the password reset link is correct",
              type: "error",
            }),
          );
      },
    }),
    changePassword: builder.mutation({
      query: ({ oldPassword, password, confirmPassword }) => ({
        url: "/users/changePassword",
        method: "PUT",
        body: { oldPassword, password, confirmPassword },
      }),
    }),
    getAllUsers: builder.query({
      query: ({
        // role, searchUser, clinicId, skip, limit,
        role,
        searchUser,
        clinicId,
        pharmacyId,
        skip,
        limit,
        isAdminVerified,
        status,
      }) => ({
        url: "/admin/getAllUsers",
        method: "GET",
        params: {
          role,
          searchUser,
          clinicId,
          pharmacyId,
          skip,
          limit: limit || "10000000",
          isAdminVerified,
          status,
        },
      }),
      // providesTags: (_, __, arg) => (arg.role === 3 ? ['doctors'] : ['patients']),
      providesTags: (_, __, arg) =>
        arg.role === 3
          ? ["doctors"]
          : ["patients", "clinic_staff", "pharmacy_user"],
      transformResponse: (res) => res,
    }),
    blockUnblockUser: builder.mutation({
      query: ({ id, role, isBlocked }) => ({
        url: "/admin/blockUnblockUser",
        method: "PUT",
        body: { id, role, isBlocked },
      }),

      invalidatesTags: ["clinic_staff", "pharmacy_user"],

      onQueryStarted({ id, role, isBlocked }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          kifAdminApi.util.updateQueryData("getAllUsers", { role }, (draft) => {
            const users = draft?.data?.users;

            if (!Array.isArray(users)) {
              console.log("Invalid users cache:", draft);
              return;
            }

            const index = users.findIndex((user) => user._id === id);

            if (index !== -1) {
              users[index].isBlocked = !!isBlocked;
            }
          }),
        );

        queryFulfilled
          .then(() => {
            notification({
              title: "Success!",
              description: isBlocked
                ? "User blocked successfully"
                : "User un-blocked successfully",
              type: "success",
            });
          })
          .catch((err) => {
            notification({
              type: "error",
              title: isBlocked
                ? "Unable to block user!"
                : "Unable to unblock user!",
              description:
                err?.error?.data?.message ||
                "Something went wrong. Please try again later.",
            });

            patchResult.undo();
          });
      },
    }),
    deleteUser: builder.mutation({
      query: ({ id, role, isDeleted }) => ({
        url: "/admin/deleteUser",
        method: "PUT",
        body: { id, role, isDeleted },
      }),

      invalidatesTags: ["clinic_staff", "pharmacy_user"],

      onQueryStarted({ id, role }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          kifAdminApi.util.updateQueryData("getAllUsers", { role }, (draft) => {
            const users = draft?.data?.users;

            if (!Array.isArray(users)) {
              return;
            }

            const index = users.findIndex((user) => user._id === id);

            if (index !== -1) {
              users.splice(index, 1);

              if (draft?.data?.usersCount > 0) {
                draft.data.usersCount -= 1;
              }
            }
          }),
        );

        queryFulfilled
          .then(() => {
            notification({
              title: "Success!",
              description: "User deleted successfully",
              type: "success",
            });
          })
          .catch(() => {
            notification({
              type: "error",
              title: "Unable to delete user!",
              description:
                "Something went wrong. Please try again later after sometime.",
            });

            patchResult.undo();
          });
      },
    }),
    getQualificationsList: builder.query({
      query: () => ({
        url: "/admin/getQualificationsList",
        method: "GET",
      }),
      transformResponse: (res) => res.data.qualification,
    }),
    getSpecialitiesList: builder.query({
      query: () => ({
        url: "/admin/getSpecialitiesList",
        method: "GET",
      }),
      transformResponse: (res) => res.data.speciality,
    }),
    addDoctor: builder.mutation({
      query: (newDoctor) => ({
        url: "/admin/addDoctors",
        method: "POST",
        body: newDoctor,
      }),
      invalidatesTags: ["doctors"],
    }),
    addPatient: builder.mutation({
      query: (newPatient) => ({
        url: "/users/addPatient",
        method: "POST",
        body: newPatient,
      }),
      invalidatesTags: ["patients"],
    }),
    getUserDetails: builder.query({
      query: ({ id }) => ({
        url: "/users/getUserDetails",
        method: "GET",
        params: { id },
      }),
      transformResponse: (res) => res?.data?.user,
      providesTags: ["user"],
    }),
    getUserDetailsForDoctor: builder.query({
      query: ({ id }) => ({
        url: "/users/getUserDetails",
        method: "GET",
        params: { id },
      }),
      transformResponse: (res) => res?.data,
      providesTags: ["user"],
    }),
    updateProfile: builder.mutation({
      query: ({ role, ...updateData }) => ({
        url: "/users/updateProfile",
        method: "PUT",
        body: updateData,
      }),
      // invalidatesTags: (_, __, { role }) => (role === 3 ? ['doctors'] : role === 1 ? ['user'] : []),
      // invalidatesTags: (_, __, { role }) => (role === 3 ? ['doctors'] : (role === 5 || role === 6) ? ['clinic_staff'] : role === 1 ? ['user'] : []),
      invalidatesTags: (_, __, { role }) =>
        role === 3
          ? ["doctors"]
          : role === 5 || role === 6
            ? ["clinic_staff"]
            : role === 7
              ? ["pharmacy_user"]
              : role === 1
                ? ["user"]
                : [],
    }),
    uploadFile: builder.mutation({
      query: (body) => ({
        url: "/common/uploadFile",
        method: "POST",
        body,
      }),
    }),
    getAppointments: builder.query({
      query: ({ searchPatient, bookingStatus, limit, page }) => ({
        url: "/booking/getBookingsList",
        method: "GET",
        params: {
          limit: limit || 100,
          page: page || 1,
          searchPatient,
          bookingStatus,
        },
      }),
      providesTags: ["appointmentList"],
      transformResponse: (res) => res?.data,
    }),
    updateAppointmentStatus: builder.mutation({
      query: ({ id }) => ({
        url: `/admin/updateAppointmentStatus/${id}`,
        method: "PUT",
      }),
      invalidatesTags: ["appointmentList"],
    }),
    getDashboard: builder.query({
      query: () => ({
        url: "/admin/getDashboard",
        method: "GET",
      }),
      transformResponse: (res) => res?.data,
    }),
    getTransactions: builder.query({
      query: ({ isForAdminPanel, limit }) => ({
        url: "/users/getTransactionData",
        method: "GET",
        params: {
          isForAdminPanel,
          limit: 10000000,
        },
      }),
      providesTags: (_, __, arg) =>
        arg.role === 3 ? ["doctors"] : ["patients"],
      transformResponse: (res) => res?.data?.transactionData,
    }),
    getSpecialityDetails: builder.query({
      query: ({ id }) => ({
        url: "/admin/getSpecialityDetails",
        method: "GET",
        params: { id },
      }),
      transformResponse: (res) => res?.data,
      providesTags: ["speciality"],
    }),
    addSpeciality: builder.mutation({
      query: (newSpeciality) => ({
        url: "/admin/addSpeciality",
        method: "POST",
        body: newSpeciality,
      }),
      invalidatesTags: ["specialties"],
    }),
    updateSpeciality: builder.mutation({
      query: ({ ...updateData }) => ({
        url: "/admin/updateSpeciality",
        method: "PUT",
        body: updateData,
      }),
      invalidatesTags: ["specialties"],
    }),
    blockUnblockSpeciality: builder.mutation({
      query: ({ id, isBlocked }) => ({
        url: "/admin/blockUnblockSpeciality",
        method: "PUT",
        body: { id, isBlocked },
      }),
      invalidatesTags: ["specialties"],
      onQueryStarted({ id, isBlocked }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          kifAdminApi.util.updateQueryData(
            "getSpecialitiesList",
            { isBlocked },
            (draft) => {
              const i = draft.findIndex((el) => el._id === id);
              draft[i].isBlocked = !!isBlocked;
            },
          ),
        );
        queryFulfilled
          .then(() =>
            notification({
              title: "Success!",
              description: isBlocked
                ? "Specialty blocked successfully"
                : "Specialty un-blocked successfully",
              type: "success",
            }),
          )
          .catch(() => {
            notification({
              type: "error",
              title: isBlocked
                ? "Unable to block specialty!"
                : "Unable to unblock specialty!",
              description:
                "Something went wrong. Please try again later after sometime.",
            });
            patchResult.undo();
          });
      },
    }),
    deleteSpeciality: builder.mutation({
      query: ({ id, isDeleted }) => ({
        url: "/admin/deleteSpeciality",
        method: "PUT",
        body: { id, isDeleted },
      }),
      invalidatesTags: ["specialties"],
      onQueryStarted({ id }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          kifAdminApi.util.updateQueryData(
            "getSpecialitiesList",
            undefined,
            (draft) => {
              const i = draft.findIndex((el) => el._id === id);
              draft.splice(i, 1);
            },
          ),
        );
        queryFulfilled
          .then(() =>
            notification({
              title: "Success!",
              description: "Specialty deleted successfully",
              type: "success",
            }),
          )
          .catch(() => {
            notification({
              type: "error",
              title: "Unable to delete specialty!",
              description:
                "Something went wrong. Please try again later after sometime.",
            });
            patchResult.undo();
          });
      },
    }),
    getAdminSpecialitiesList: builder.query({
      query: () => ({
        url: "/admin/getSpecialitiesList",
        method: "GET",
        params: {
          limit: 10000000,
          isForAdminList: 1,
        },
      }),
      providesTags: ["specialties"],
      transformResponse: (res) => res.data.speciality,
    }),
    getExpertizeBySpeciality: builder.query({
      query: ({ id }) => ({
        url: `/admin/getExpertizeBySpeciality/${id}`,
        method: "GET",
      }),
      transformResponse: (res) => res.data?.expertize,
    }),

    getAdminExpertiseList: builder.query({
      query: () => ({
        url: "/admin/getExpertizeList?limit=200",
        method: "GET",
        // params: {
        //   limit: 10000000,
        //   isForAdminList: 1,
        // },
      }),
      // providesTags: ['qualifications'],
      transformResponse: (res) => res.data.expertize,
    }),

    // qualifications
    getAdminQualificationsList: builder.query({
      query: () => ({
        url: "/admin/getQualificationsList",
        method: "GET",
        params: {
          limit: 10000000,
          isForAdminList: 1,
        },
      }),
      providesTags: ["qualifications"],
      transformResponse: (res) => res.data.qualification,
    }),
    updateQualification: builder.mutation({
      query: ({ ...updateData }) => ({
        url: "/admin/updateQualification",
        method: "PUT",
        body: updateData,
      }),
      invalidatesTags: ["qualifications"],
    }),
    addQualification: builder.mutation({
      query: (newQualification) => ({
        url: "/admin/addQualification",
        method: "POST",
        body: newQualification,
      }),
      invalidatesTags: ["qualifications"],
    }),
    getQualificationDetails: builder.query({
      query: ({ id }) => ({
        url: "/admin/getQualificationDetails",
        method: "GET",
        params: { id },
      }),
      transformResponse: (res) => res?.data,
      providesTags: ["qualification"],
    }),
    blockUnblockQualification: builder.mutation({
      query: ({ id, isBlocked }) => ({
        url: "/admin/blockUnblockQualification",
        method: "PUT",
        body: { id, isBlocked },
      }),
      invalidatesTags: ["qualifications"],
      onQueryStarted({ id, isBlocked }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          kifAdminApi.util.updateQueryData(
            "getQualificationsList",
            { isBlocked },
            (draft) => {
              const i = draft.findIndex((el) => el._id === id);
              draft[i].isBlocked = !!isBlocked;
            },
          ),
        );
        queryFulfilled
          .then(() =>
            notification({
              title: "Success!",
              description: isBlocked
                ? "Qualification blocked successfully"
                : "Qualification un-blocked successfully",
              type: "success",
            }),
          )
          .catch(() => {
            notification({
              type: "error",
              title: isBlocked
                ? "Unable to block qualification!"
                : "Unable to unblock qualification!",
              description:
                "Something went wrong. Please try again later after sometime.",
            });
            patchResult.undo();
          });
      },
    }),
    deleteQualification: builder.mutation({
      query: ({ id, isDeleted }) => ({
        url: "/admin/deleteQualification",
        method: "PUT",
        body: { id, isDeleted },
      }),
      invalidatesTags: ["qualifications"],
      onQueryStarted({ id }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          kifAdminApi.util.updateQueryData(
            "getQualificationsList",
            undefined,
            (draft) => {
              const i = draft.findIndex((el) => el._id === id);
              draft.splice(i, 1);
            },
          ),
        );
        queryFulfilled
          .then(() =>
            notification({
              title: "Success!",
              description: "Qualification deleted successfully",
              type: "success",
            }),
          )
          .catch(() => {
            notification({
              type: "error",
              title: "Unable to delete qualification!",
              description:
                "Something went wrong. Please try again later after sometime.",
            });
            patchResult.undo();
          });
      },
    }),

    // for manual appointments

    getDoctors: builder.query({
      query: ({
        // longitude, latitude, radius, skip, limit,
        longitude,
        latitude,
        radius,
        skip,
        limit,
        searchUser,
      }) => ({
        url: "/patient/getDoctorsList",
        method: "GET",
        params: {
          longitude,
          latitude,
          skip,
          limit: 10000000,
          radius: 40,
          searchUser,
        },
      }),
      providesTags: (_, __, arg) =>
        arg.role === 3 ? ["doctors"] : ["patients"],
      transformResponse: (res) => res?.data?.users,
    }),
    // getTimeSlots: builder.query({
    //   query: ({ doctorId, startDateAndTime, endDateAndTime }) => ({
    //     url: '/patient/getAvailabilityTimeSlots',
    //     method: 'GET',
    //     params: {
    //       doctorId,
    //       startDateAndTime,
    //       endDateAndTime,
    //     },
    //   }),
    //   providesTags: (_, __, arg) => (arg.role === 3 ? ['doctors'] : ['patients']),
    //   transformResponse: (res) => res?.data?.response[0]?.availability[0]?.availabilityTime,
    // }),

    getTimeSlots: builder.query({
      query: ({
        doctorId,
        startDateAndTime,
        endDateAndTime,
        appointmentType,
      }) => ({
        url: "/patient/getAvailabilityTimeSlots",
        //  url: "/doctor/getAvailabilityAndAppointments",
        method: "GET",
        params: {
          doctorId,
          startDateAndTime,
          endDateAndTime,
          ...(appointmentType && { appointmentType }),
        },
      }),
      providesTags: (_, __, arg) =>
        arg.role === 3 ? ["doctors"] : ["patients"],
      transformResponse: (res) => res?.data?.response[0],
    }),
    // for booking
    createBooking: builder.mutation({
      query: (bookingData) => ({
        url: "/booking/createAppointment",
        method: "POST",
        body: bookingData,
      }),
      invalidatesTags: ["booking"],
    }),

    // verfiy doctor
    verifyDoctor: builder.mutation({
      query: (body) => ({
        url: "/admin/verifyUserByAdmin",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["doctors"],
    }),

    // reviews
    getReviewList: builder.query({
      query: ({ longitude, latitude, radius, skip, limit, searchReview }) => ({
        url: "/users/getRatingList",
        method: "GET",
        params: {
          limit: 100,
          skip: 0,
          searchUser: searchReview,
        },
      }),
      providesTags: ["reviews"],
      transformResponse: (res) => res?.data?.allData,
    }),

    // verfiy reviews
    verifyReviews: builder.mutation({
      query: (body) => ({
        url: "/admin/verifyReviewByAdmin",
        method: "PUT",
        body,
      }),
      onQueryStarted({ id, isBlocked }, { dispatch, queryFulfilled }) {
        queryFulfilled
          .then(() =>
            notification({
              title: "Review Approved!",
              description: "Review Approved Successfully!",
              type: "success",
            }),
          )
          .catch(() => {
            notification({
              type: "error",
              title: "Something went wrong",
              description:
                "Something went wrong. Please try again later after sometime.",
            });
            // patchResult.undo();
          });
      },
      invalidatesTags: ["reviews"],
    }),

    // prescriptions and invoices
    getPrescriptions: builder.query({
      query: ({ urlString }) => ({
        url: `/doctor/getPdfList?${urlString}&pdfType=1`,
        method: "GET",
        params: {
          limit: 100,
          skip: 0,
        },
      }),
      transformResponse: (res) => res?.data,
    }),

    getInvoices: builder.query({
      query: ({ urlString }) => ({
        url: `/doctor/getPdfList?${urlString}&pdfType=2`,
        method: "GET",
        params: {
          limit: 100,
          skip: 0,
        },
      }),
      transformResponse: (res) => res?.data,
    }),

    getPdf: builder.query({
      query: ({ type, id }) => ({
        url: `/${type}/getPdf?id=${id}`,
        method: "GET",
      }),
    }),

    // notes for profile

    addProfileNote: builder.mutation({
      query: (body) => ({
        url: "/doctor/notes",
        method: "POST",
        body,
      }),
      invalidatesTags: ["notes"],
    }),

    getProfileNotes: builder.query({
      query: ({ patientId }) => ({
        url: `/doctor/notes?patientId=${patientId}`,
        method: "GET",
      }),
      providesTags: ["notes"],
      transformResponse: (res) => res?.data,
    }),

    deleteProfileNote: builder.mutation({
      query: ({ _id }) => ({
        url: `/doctor/notes?id=${_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["notes"],
    }),

    // Recommendation APIs
    getRecommendedDoctors: builder.query({
      query: () => ({
        url: "/admin/getRecommendedDoctors",
        method: "GET",
      }),
      providesTags: ["recommended_doctors"],
      transformResponse: (res) => res?.data,
    }),

    updateRecommendedDoctors: builder.mutation({
      query: ({ id, recommended = false }) => ({
        url: `/admin/updateRecommendedDoctor?doctorId=${id}&isRecommended=${recommended}`,
        method: "PUT",
      }),
      invalidatesTags: ["recommended_doctors"],
    }),

    getRecommendedSpecialities: builder.query({
      query: () => ({
        url: "/admin/getRecommendedSpecialities",
        method: "GET",
      }),
      providesTags: ["recommended_specialities"],
      transformResponse: (res) => res?.data,
    }),

    updateRecommendedSpecialities: builder.mutation({
      query: ({ id, recommended = false }) => ({
        url: `/admin/updateRecommendedSpecialities?specialityId=${id}&isRecommended=${recommended}`,
        method: "PUT",
      }),
      invalidatesTags: ["recommended_specialities"],
    }),
    addClinicAndClinicStaff: builder.mutation({
      query: (body) => ({
        // url: '/clinics',
        url: "/clinics/createClinic",
        method: "POST",
        body,
      }),
      invalidatesTags: ["clinics"],
    }),

    deleteClinic: builder.mutation({
      query: ({ id }) => ({
        url: `/clinics/deleteclinic/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["clinics"],
    }),

    blockUnblockClinic: builder.mutation({
      query: ({ id, isBlocked }) => ({
        url: "/clinics/blockUnblockClinic",
        method: "PUT",
        body: { id, isBlocked },
      }),
      invalidatesTags: ["clinics"],
      onQueryStarted({ id, isBlocked }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          kifAdminApi.util.updateQueryData(
            "getAllClinics",
            { isBlocked },
            (draft) => {
              const i = draft.findIndex((el) => el._id === id);
              draft[i].isBlocked = !!isBlocked;
            },
          ),
        );
        queryFulfilled
          .then(() =>
            notification({
              title: "Success!",
              description: isBlocked
                ? "Clinic blocked successfully"
                : "Clinic un-blocked successfully",
              type: "success",
            }),
          )
          .catch(() => {
            notification({
              type: "error",
              title: isBlocked
                ? "Unable to block clinic!"
                : "Unable to unblock clinic!",
              description:
                "Something went wrong. Please try again later after sometime.",
            });
            patchResult.undo();
          });
      },
    }),
    getAllClinics: builder.query({
      query: () => ({
        url: "clinics?role=4",
        method: "GET",
      }),
      providesTags: ["clinics"],
    }),
    getClinicDetails: builder.query({
      query: ({ id }) => ({
        url: `clinics/getClinicDetails/${id}`,
        method: "GET",
      }),
      transformResponse: (res) => res?.data,
    }),
    // updateClinic: builder.mutation({
    //   query: ({ updateData }) => ({
    //     url: `clinics/updateClinicDetails/${updateData.id}`,
    //     method: 'PUT',
    //     body: updateData,
    //   }),
    // }),

    updateClinic: builder.mutation({
      query: (updateData) => {
        const { id, ...body } = updateData;
        return {
          url: `clinics/updateClinicDetails/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["clinics"],
    }),
    loginMonitor: builder.query({
      query: () => ({
        url: "admin/getSessionDetails",
        method: "GET",
      }),
      transformResponse: (res) => res?.data,
    }),
    addClinicStaff: builder.mutation({
      query: (body) => ({
        url: "/users/signUp",
        method: "POST",
        body,
      }),
      invalidatesTags: ["clinic_staff"],
    }),
    getTransactionsForAdmin: builder.query({
      query: ({ limit, page, payoutStatus, search }) => ({
        url: `/admin/getAllTransactions?limit=${limit}&page=${page}&payoutStatus=${payoutStatus}&search=${search}`,
        method: "GET",
      }),
      providesTags: ["Transactions"],
      transformResponse: (res) => res,
    }),

    updateTransactionPayout: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/admin/transactions/${id}/payout`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Transactions"],
    }),

    getAllTaxRate: builder.query({
      // query: ({limit, page}) => ({
      query: () => ({
        // url: `admin/getAllTaxRates?limit=${limit}&page=${page}`,
        // url: `admin/getAllTaxRates?limit=${limit}`,
        url: `admin/getAllTaxRates?limit=10000`,
        method: "GET",
      }),
      providesTags: ["tax"],
      transformResponse: (res) => res?.data,
    }),
    getTaxRateById: builder.query({
      query: ({ id }) => ({
        url: `admin/getTaxRate/${id}`,
        method: "GET",
      }),
      transformResponse: (res) => res?.data,
    }),
    addTaxRate: builder.mutation({
      query: (body) => ({
        url: "/admin/addTaxRate",
        method: "POST",
        body,
      }),
      invalidatesTags: ["tax"],
    }),

    updateTaxRate: builder.mutation({
      query: (updateData) => {
        const { id, ...body } = updateData;
        return {
          url: `admin/updateTaxRate/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["tax"],
    }),
    deleteTaxRate: builder.mutation({
      query: ({ id, isDeleted }) => ({
        url: `admin/updateTaxRate/${id}`,
        method: "PUT",
        body: { id, isDeleted },
      }),
      invalidatesTags: ["tax"],
      onQueryStarted({ id, role }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          kifAdminApi.util.updateQueryData(
            "getAllTaxRate",
            { role },
            (draft) => {
              const i = draft.findIndex((el) => el._id === id);
              draft.splice(i, 1);
            },
          ),
        );
        queryFulfilled
          .then(() =>
            notification({
              title: "Success!",
              description: "GST deleted successfully",
              type: "success",
            }),
          )
          .catch(() => {
            notification({
              type: "error",
              title: "Unable to delete GST!",
              description:
                "Something went wrong. Please try again later after sometime.",
            });
            patchResult.undo();
          });
      },
    }),

    getAllPharmacy: builder.query({
      query: () => ({
        url: "/pharmacy?limit=100000",
        method: "GET",
      }),
      transformResponse: (res) => res?.data,
      providesTags: ["pharmacy"],
    }),

    getPharmacyDetails: builder.query({
      query: ({ id }) => ({
        url: `/pharmacy?limit=1&pharmacyId=${id}`,
        method: "GET",
      }),
      transformResponse: (res) => res?.data?.data[0],
    }),

    addPharmacy: builder.mutation({
      query: (body) => ({
        url: "/pharmacy/createPharmacy",
        method: "POST",
        body,
      }),
      invalidatesTags: ["pharmacy"],
    }),

    deletePharmacy: builder.mutation({
      query: ({ id }) => ({
        url: `/pharmacy/deletePharmacy/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["pharmacy"],
    }),

    blockUnblockPharmacy: builder.mutation({
      query: ({ id, isBlocked }) => ({
        url: `/pharmacy/blockUnblockPharmacy/${id}`,
        method: "PUT",
        body: { id, isBlocked },
      }),
      invalidatesTags: ["pharmacy"],
      onQueryStarted({ id, isBlocked }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          kifAdminApi.util.updateQueryData(
            "getAllPharmacy",
            { isBlocked },
            (draft) => {
              const i = draft.findIndex((el) => el._id === id);
              draft[i].isBlocked = !!isBlocked;
            },
          ),
        );
        queryFulfilled
          .then(() =>
            notification({
              title: "Success!",
              description: isBlocked
                ? "Pharmacy blocked successfully"
                : "Pharmacy un-blocked successfully",
              type: "success",
            }),
          )
          .catch(() => {
            notification({
              type: "error",
              title: isBlocked
                ? "Unable to block pharmacy!"
                : "Unable to unblock pharmacy!",
              description:
                "Something went wrong. Please try again later after sometime.",
            });
            patchResult.undo();
          });
      },
    }),

    updatePharmacyDetails: builder.mutation({
      query: (updateData) => {
        const { id, ...body } = updateData;
        return {
          url: `/pharmacy/updatePharmacyDetails/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["pharmacy"],
    }),

    addPharmacyUser: builder.mutation({
      query: (body) => ({
        url: "/users/signUp",
        method: "POST",
        body,
      }),
      invalidatesTags: ["pharmacy_user"],
    }),
    ScreeningList: builder.query({
      query: ({ limit, skip }) => ({
        url: `/patient/getScreenings?limit=${limit}&skip=${skip}`,
        method: "GET",
      }),
      transformResponse: (res) => res?.data,
      providesTags: ["screenings"],
    }),
    uploadScreeningFile: builder.mutation({
      query: (body) => ({
        url: "/patient/uploadScreeningResponse",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["screenings"],
    }),
    deleteScreeningDocument: builder.mutation({
      query: ({ surveyId, documentId }) => ({
        url: "/admin/deleteScreeningDocument",
        method: "POST",
        body: { surveyId, documentId },
      }),
      invalidatesTags: ["Screening"],
    }),
    uploadMultipleFiles: builder.mutation({
      query: (body) => ({
        url: "/common/uploadMultipleFiles",
        method: "POST",
        body,
      }),
    }),
    GetScreeningDetails: builder.query({
      query: ({ id }) => ({
        url: `/patient/getScreeningResponse/${id}`,
        method: "GET",
      }),
      transformResponse: (res) => res?.data,
      providesTags: ["screenings"],
    }),
    getProviderFeeRevisionRequest: builder.query({
      query: ({ status, type }) => ({
        // url: `/admin/provider-fee-revision-requests`,
        url: `/admin/feeRevisionRequests`,
        method: "GET",
        params: {
          limit: 10000000,
          status,
          type,
        },
      }),
      transformResponse: (res) => res?.data,
      providesTags: ["providerFeeRevision"],
    }),
    updateProviderFeeRevisionRequests: builder.mutation({
      query: ({ body, id }) => ({
        // url: `/admin/provider-fee-revision-requests/${id}/${action}`,
        // url: `/admin/feeRevisionRequests/${id}/${action}`,
        url: `/admin/feeRevisionRequests/${id}`,
        method: "PUT",
        ...(body && { body }),
      }),
      invalidatesTags: ["providerFeeRevision"],
    }),
    getFeeRevisionHistory: builder.query({
      query: ({ status, type, userId }) => ({
        url: `/admin/feeRevisionHistory`,
        method: "GET",
        params: {
          limit: 10000000,
          status,
          type,
          userId,
        },
      }),
      transformResponse: (res) => res?.data,
      providesTags: ["FeeRevisionHistory"],
    }),

    getAllMasterDocuments: builder.query({
      query: ({ search, status, providerType }) => ({
        url: `/admin/getAllMasterDocuments`,
        method: "GET",
        params: {
          limit: 1000,
          status,
          providerType,
          search,
        },
      }),
      transformResponse: (res) => res?.data?.data,
      providesTags: ["masterDocument"],
    }),

    addMasterDocument: builder.mutation({
      query: (body) => ({
        url: "/admin/addMasterDocument",
        method: "POST",
        body,
      }),
      invalidatesTags: ["masterDocument"],
    }),

    getMasterDocumentById: builder.query({
      query: ({ id }) => ({
        url: `/admin/getMasterDocument/${id}`,
        method: "GET",
      }),
      transformResponse: (res) => res?.data,
    }),

    updateMasterDocument: builder.mutation({
      query: (updateData) => {
        const { id, body } = updateData;
        return {
          url: `/admin/updateMasterDocument/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["masterDocument"],
    }),

    deleteMasterDocument: builder.mutation({
      query: ({ id }) => ({
        url: `/admin/deleteMasterDocument/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["masterDocument"],
    }),

    activeInactiveMasterDoc: builder.mutation({
      query: ({ id }) => ({
        url: `/admin/masterDocument/${id}/status`,
        method: "PATCH",
      }),
      invalidatesTags: ["masterDocument"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLoginMutation,
  useLoginMonitorQuery,
  useUpdateClinicMutation,
  useGetClinicDetailsQuery,
  useLazyGetClinicDetailsQuery,
  useGetAllClinicsQuery,
  useVerifyTwoFactorAuthMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
  useBlockUnblockUserMutation,
  useDeleteUserMutation,
  useGetAllUsersQuery,
  useLazyGetAllUsersQuery,
  useGetQualificationsListQuery,

  useGetAdminExpertiseListQuery,
  useGetSpecialitiesListQuery,
  useGetExpertizeBySpecialityQuery,
  useLazyGetExpertizeBySpecialityQuery,
  useAddDoctorMutation,
  useAddPatientMutation,
  useGetUserDetailsQuery,
  useLazyGetUserDetailsQuery,
  useGetUserDetailsForDoctorQuery,
  useLazyGetUserDetailsForDoctorQuery,
  useUpdateProfileMutation,
  useUploadFileMutation,
  useGetAppointmentsQuery,
  useLazyGetAppointmentsQuery,
  useUpdateAppointmentStatusMutation,
  useGetDashboardQuery,
  useGetTransactionsQuery,
  useGetAdminSpecialitiesListQuery,
  useBlockUnblockSpecialityMutation,
  useDeleteSpecialityMutation,
  useUpdateSpecialityMutation,
  useAddSpecialityMutation,
  useLazyGetSpecialityDetailsQuery,
  useBlockUnblockQualificationMutation,
  useGetAdminQualificationsListQuery,
  useDeleteQualificationMutation,
  useUpdateQualificationMutation,
  useAddQualificationMutation,
  useLazyGetQualificationDetailsQuery,
  useGetDoctorsQuery,
  useGetTimeSlotsQuery,
  useLazyGetTimeSlotsQuery,
  useCreateBookingMutation,
  useVerifyDoctorMutation,
  useGetReviewListQuery,
  useVerifyReviewsMutation,
  useGetPrescriptionsQuery,
  useGetInvoicesQuery,
  useLazyGetPdfQuery,
  useAddProfileNoteMutation,
  useGetProfileNotesQuery,
  useDeleteProfileNoteMutation,
  useGetRecommendedDoctorsQuery,
  useUpdateRecommendedDoctorsMutation,
  useGetRecommendedSpecialitiesQuery,
  useUpdateRecommendedSpecialitiesMutation,
  useAddClinicAndClinicStaffMutation,
  useAddClinicStaffMutation,
  useDeleteClinicMutation,
  useBlockUnblockClinicMutation,
  useGetTransactionsForAdminQuery,
  useUpdateTransactionPayoutMutation,
  useAddTaxRateMutation,
  useGetAllTaxRateQuery,
  useGetTaxRateByIdQuery,
  useLazyGetTaxRateByIdQuery,
  useUpdateTaxRateMutation,
  useDeleteTaxRateMutation,
  useGetAllPharmacyQuery,
  useGetPharmacyDetailsQuery,
  useLazyGetPharmacyDetailsQuery,
  useAddPharmacyMutation,
  useBlockUnblockPharmacyMutation,
  useDeletePharmacyMutation,
  useUpdatePharmacyDetailsMutation,
  useAddPharmacyUserMutation,
  useScreeningListQuery,
  useUploadScreeningFileMutation,
  useDeleteScreeningDocumentMutation,
  useUploadMultipleFilesMutation,
  useGetScreeningDetailsQuery,
  useGetProviderFeeRevisionRequestQuery,
  useLazyGetProviderFeeRevisionRequestQuery,
  useUpdateProviderFeeRevisionRequestsMutation,
  useGetFeeRevisionHistoryQuery,
  useLazyGetFeeRevisionHistoryQuery,
  useGetAllMasterDocumentsQuery,
  useLazyGetAllMasterDocumentsQuery,
  useAddMasterDocumentMutation,
  useGetMasterDocumentByIdQuery,
  useLazyGetMasterDocumentByIdQuery,
  useUpdateMasterDocumentMutation,
  useDeleteMasterDocumentMutation,
  useActiveInactiveMasterDocMutation,
} = kifAdminApi;
